import { useQuery } from 'react-query';

import {
  type GetCardLimitsIncreaseStatusInput,
  getCardLimitsIncreaseStatus,
} from 'modules/cards/api/getCardLimitsIncreaseStatus';

export const useGetCardLimitsIncreaseStatus = ({
  companyId,
  enabled = true,
}: GetCardLimitsIncreaseStatusInput & { enabled?: boolean }) => {
  return useQuery(
    ['cardProductRegulatoryLimits', companyId],
    () =>
      getCardLimitsIncreaseStatus({
        companyId,
      }),
    {
      enabled,
    },
  );
};
